var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('component',_vm._b({},'component',_vm.elementOptions,false),[(_vm.data.content)?[_vm._l((_vm.data.content),function(ele){return [_c('Element',{attrs:{"data":ele,"linkColor":_vm.linkColor}})]})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }